import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { CreateLoginDialog } from "./components/create-login-dialog";
import { LoginsTable } from "./components/logins-table";

export const DashboardPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight dark:text-white">Login3s</h2>
          <p className="text-muted-foreground dark:text-white">
            Create, start, stop, and edit logins.
          </p>
        </div>
        <CreateLoginDialog />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Login Console</CardTitle>
        </CardHeader>

        <CardContent>
          <LoginsTable />
        </CardContent>
      </Card>
    </div>
  );
};
